import React from 'react';
import { Icon } from '@iconify/react';

/**
 * Shown where the highlighted "Campaign opportunities" block would sit when a
 * lead has NO campaign-scoped opportunities (lvl2.opportunities empty).
 *
 * Why: users read the profile/company lists below as campaign detections —
 * the section used to vanish silently, so there was nothing telling them the
 * distinction. This keeps the slot visible with an explicit "none detected"
 * state and one line explaining what the remaining lists are.
 *
 * Shared by the ISR workspace opportunities tab and the Lead Details modal
 * (OpportunitiesTab) — the same message in both surfaces.
 */
export const CampaignOpportunitiesNotice: React.FC = () => (
    <div className="rounded-2xl border border-dashed border-white/12 bg-white/[0.02] px-4 py-3.5" role="note" aria-label="No campaign opportunities detected">
        <div className="flex flex-wrap items-center gap-2">
            <Icon icon="bx:target-lock" className="h-4 w-4 shrink-0 text-white/40" aria-hidden="true" />
            <h2 className="text-[15px] font-medium text-white/80">Campaign opportunities</h2>
            <span className="rounded-md border border-white/10 bg-white/[0.035] px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-[0.1em] text-white/45">
                None detected
            </span>
        </div>
        <p className="mt-1.5 text-[12px] leading-5 text-white/45">
            No opportunities specific to this campaign were detected for this lead yet. The opportunities listed below come from the lead's profile and market intelligence — <span className="font-semibold text-white/60">not from this campaign</span>.
        </p>
    </div>
);
